'use client'

import Image from 'next/image'

import { Accordion, Container, Filters, If, SectionHeader } from '@/components'

import { useHelp } from './useHelp'

import { FILTERS } from './constants'

import styles from './Help.module.scss'

export const Help = ({ title, image, shouldRenderFilters }) => {
  const {
    faqItems,
    activeFilterIndex,
    activeAccordionIndex,
    setActiveFilterIndex,
    handleTrigger
  } = useHelp({
    shouldRenderFilters
  })

  return (
    <section id="ajuda" className={styles.help}>
      <Container>
        <SectionHeader tagText="Ajuda" title={title} />

        <div className={styles.help__wrapper}>
          <If
            condition={shouldRenderFilters}
            renderIf={
              <Filters
                variant="secondary"
                section="help"
                filters={FILTERS}
                activeFilterIndex={activeFilterIndex}
                setActiveFilterIndex={setActiveFilterIndex}
              />
            }
            renderElse={
              <Image
                src={image?.src}
                alt={image?.alt}
                loading="lazy"
                width={598}
                height={546}
                className={styles.help__img}
              />
            }
          />

          <div>
            {faqItems.map(({ title, content }, index) => (
              <Accordion
                key={`${title}-${index}`}
                index={index}
                title={title}
                content={content}
                isActiveItem={activeAccordionIndex === index}
                handleTrigger={handleTrigger}
              />
            ))}
          </div>
        </div>
      </Container>
    </section>
  )
}
